import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
//import Detail from "../views/detail/Detail";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () => import('views/home/Homeindex'),
        meta: {
            title: '首页'
        },
        children: [
            {
                path: '/index',
                component: () => import('views/index/index2'),
                name: "首页子",
                meta: {
                    title: '首页'
                },
            }, {
                path: '/default',
                component: () => import('views/default/index'),
                name: "待开发页",
                meta: {
                    title: '待开发页'
                },
            },

            // {
            //   path: '/role_set',
            //   component:()=>import('views/role_set/Index'),
            //   meta: {
            //     title: '角色设置'
            //   }
            // },{
            //   path: '/menu',
            //   component:()=>import('views/menu/Index'),
            //   meta: {
            //     title: '菜单设置'
            //   }
            // },
            {
                path: '/customer/information',
                component: () => import('views/customer/information'),
                meta: {
                    title: '客户信息管理'
                }
            },
            {
                path: '/customer/dealerInfo',
                component: () => import('views/customer/dealerInfo'),
                meta: {
                    title: '经销商信息管理'
                }
            },
            {
                path: '/customer/customerAccount',
                component: () => import('views/customer/customerAccount'),
                meta: {
                    title: '客户账号管理'
                }
            }, {
                name: "/customer/resetCustomerPwd",
                path: '/customer/resetCustomerPwd',
                component: () => import('views/customer/resetCustomerPwd'),
                meta: {
                    title: '客户账号管理-密码重置'
                }
            },
            {
                path: '/customer/custCenter',
                component: () => import('views/customer/custCenter'),
                meta: {
                    title: '空压机客户区域管理'
                }
            },
            {
                path: '/customer/paccustCenter',
                component: () => import('views/customer/pacCustomerCenter'),
                meta: {
                    title: '空压机客户区域管理'
                }
            },
            {
                path: '/customer/bvcustCenter',
                component: () => import('views/customer/bvCustomerCenter'),
                meta: {
                    title: '空压机客户区域管理'
                }
            },
            {
                path: '/device/register',
                name: "/device/register",
                component: () => import('views/device/register'),

                meta: {
                    title: '空压机登记'
                }
            },
            {
                path: '/device/endurance',
                name: "/device/endurance",
                component: () => import('views/device/endurance'),

                meta: {
                    title: '耐久性测试'
                }
            },
            {
                path: '/device/enduranceMonitor',
                name: "/device/enduranceMonitor",
                component: () => import('views/device/enduranceMonitor'),

                meta: {
                    title: '耐久性测试监控'
                }
            },
            {
                path: '/device/deviceStation',
                component: () => import('views/device/deviceStation'),
                meta: {
                    title: '空压站管理'
                }
            },
            {
                path: '/ccn',
                component: () => import('views/ccn/index'),
                meta: {
                    title: 'CCN及点表'
                }
            },
            {
                path: '/ccn/pac',
                component: () => import('views/ccn/pac'),
                meta: {
                    title: 'PAC点表'
                }
            },
            {
                path: '/ccn/bv',
                component: () => import('views/ccn/bv'),
                meta: {
                    title: 'BV点表'
                }
            },
            {
                path: '/ccn/lr',
                component: () => import('views/ccn/lr'),
                meta: {
                    title: 'LR点表'
                }
            },
            {
                path: '/ccn/endurance',
                component: () => import('views/ccn/endurance'),
                meta: {
                    title: '耐久性测试点表'
                }
            },
            {
                path: '/device/deviceModel',
                component: () => import('views/device/deviceModel'),
                meta: {
                    title: '设备'
                }
            },
            {
                path: '/device/gallery',
                component: () => import('views/device/gallery'),
                meta: {
                    title: '图片库'
                }
            },
            {
                path: '/gateway',
                component: () => import('views/device/gateway'),
                meta: {
                    title: '网关登记'
                }
            },
            {
                path: '/OTAList',
                component: () => import('views/device/OTAList'),
                meta: {
                    title: 'OTA清单'
                }
            },
            {
                path: '/OTAUpgrade',
                component: () => import('views/device/OTAUpgrade'),
                meta: {
                    title: 'OTA升级'
                }
            },
            {
                path: '/monitor/list',
                component: () => import('views/monitor/list'),
                name: "/monitor/list",
                meta: {
                    title: '空压机监控列表'
                }
            },
            {
                path: '/menu',
                component: () => import('views/menu/Index'),
                meta: {
                    title: '菜单管理'
                }
            }, {
                path: '/log',
                component: () => import('views/operationLog/log'),
                meta: {
                    title: '操作日志'
                }
            },
            {
                path: '/role',
                component: () => import('views/role_set/Index'),
                meta: {
                    title: '角色设置'
                }
            },
            {
                path: '/user',
                component: () => import('views/user_rights/User_rights'),
                meta: {
                    title: '用户权限'
                }
            },
            {
                path: '/password',
                component: () => import('views/password/index'),
                meta: {
                    title: '修改密码'
                }
            },
            {
                path: '/default/noAccess',
                component: () => import('views/default/noAccess'),
                name: "/default/noAccess",
                meta: {
                    title: '无权限'
                },
            },

            {
                path: '/default/AlertInfo',
                component: () => import('views/default/AlertInfo'),
                name: "/default/AlertInfo",
                meta: {
                    title: '提示信息页'
                },
            },
            {
                path: '/Alarm/AlarmList',
                component: () => import('views/Alarm/AlarmList'),
                name: "/Alarm/AlarmList",
                meta: {
                    title: '告警查询'
                },
            },
            {
                path: '/Alarm/AlarmSet',
                component: () => import('views/Alarm/AlarmSet'),
                name: "/Alarm/AlarmSet",
                meta: {
                    title: '告警规则设置'
                },
            }, {
                path: '/Alarm/AlarmPushRule',
                component: () => import('views/Alarm/AlarmPushRule'),
                name: "/Alarm/AlarmPushRule",
                meta: {
                    title: '告警推送SFA规则'
                },
            }, {
                path: '/Alarm/NoticeList',
                component: () => import('views/Alarm/NoticeList'),
                name: "/Alarm/NoticeList",
                meta: {
                    title: '站内信'
                },
            },
            {
                path: '/Alarm/NoticeSet',
                component: () => import('views/Alarm/NoticeSet'),
                name: "/Alarm/NoticeSet",
                meta: {
                    title: '商业推送设置'
                },
            },
            {
                path: '/report/deviceStatistics',
                component: () => import('views/report/deviceStatistics'),
                name: "/report/deviceStatistics",
                meta: {
                    title: '空压机统计报表'
                },
            },
            {
                path: '/report/utilizationStatistics',
                component: () => import('views/report/UtilizationStatistics'),
                name: "/report/utilizationStatistics",
                meta: {
                    title: '利用率统计报表'
                },
            },
            {
                path: '/report/utilizationStat2',
                component: () => import('views/report/UtilizationStat2'),
                name: "/report/UtilizationStat2",
                meta: {
                    title: '利用率统计报表'
                },
            },
            {
                path: '/report/utilizationStatPac',
                component: () => import('views/report/UtilizationStatPac'),
                name: "/report/UtilizationStatPac",
                meta: {
                    title: 'PAC利用率统计报表'
                },
            },
            {
                path: '/report/installDashboard',
                component: () => import('views/report/installDashboard'),
                name: "/report/installDashboard",
                meta: {
                    title: '安装统计报表'
                },
            },
            {
                path: '/report/deviceKPI',
                component: () => import('views/report/deviceKPI'),
                name: "/report/deviceKPI",
                meta: {
                    title: '空压机KPI指标'
                },
            },
            {
                path: '/report/deviceKPI2',
                component: () => import('views/report/deviceKPI2'),
                name: "/report/deviceKPI2",
                meta: {
                    title: '空压机KPI指标2'
                },
            },
            {
                path: '/report/installKPI',
                component: () => import('views/report/installKPI'),
                name: "/report/installKPI",
                meta: {
                    title: '安装KPI指标'
                },
            },
            {
                path: '/report/deviceDetail',
                component: () => import('views/report/deviceDetail'),
                name: "/report/deviceDetail",
                meta: {
                    title: '空压机列表'
                },
            },
            {
                path: '/report/relieveDevice',
                component: () => import('views/report/unbindDevice'),
                name: "/report/relieveDevice",
                meta: {
                    title: '解绑空压机列表'
                },
            },
            {
                path: '/maintain',
                component: () => import('views/maintain/index'),
                name: "/maintain/index",
                meta: {
                    title: '预测维护'
                },
            },
            {
                path: '/maintainrecord',
                component: () => import('views/maintain/MaintainRecord'),
                name: "/maintain/MaintainRecord",
                meta: {
                    title: '服务记录'
                },
            },
            {
                path: '/SIMInfo',
                component: () => import('views/report/SIMInfo'),
                name: "/report/SIMInfo",
                meta: {
                    title: 'SIM统计报表'
                },
            },
            {
                path: '/UnicomInfo',
                component: () => import('views/report/UnicomInfo'),
                name: "/report/UnicomInfo",
                meta: {
                    title: '联通统计报表'
                },
            },
            {
                path: '/userLoginLog',
                component: () => import('views/userLoginLog/loginLog'),
                name: "/userLoginLog/loginLog",
                meta: {
                    title: '登录日志'
                }
            },
            {
                path: '/brand',
                component: () => import('views/brand/Index'),
                name: "/brand/Index",
                meta: {
                    title: '品牌管理'
                }
            },
            {
                path: '/gatherUnit',
                component: () => import('views/ccn/gatherUnit'),
                name: "/ccn/gatherUnit",
                meta: {
                    title: '品牌管理'
                }
            },
            {
                path: '/RunningTime',
                component: () => import('views/s3file/RunningTime'),
                name: "/RunningTime/Index",
                meta: {
                    title: '运行时间报表'
                }
            },
            {
                path: '/PMReport',
                component: () => import('views/s3file/PMReport'),
                name: "/PMReport/Index",
                meta: {
                    title: 'PM报表'
                }
            },
            {
                path: '/MisuseReport',
                component: () => import('views/s3file/MisuseReport'),
                name: "/MisuseReport/Index",
                meta: {
                    title: '误用报表'
                }
            },
            {
                path: '/CustomerReport',
                component: () => import('views/s3file/CustomerReport'),
                name: "/CustomerReport/Index",
                meta: {
                    title: '客户报表'
                }
            },
            {
                path: '/PartReport',
                component: () => import('views/s3file/PartReport'),
                name: "/PartReport/Index",
                meta: {
                    title: '零件查找报表'
                }
            },
            {
                path: '/AssetReport',
                component: () => import('views/s3file/AssetReport'),
                name: "/AssetReport/Index",
                meta: {
                    title: '资产月报报表'
                }
            },
            {
                path: '/AlarmReport',
                component: () => import('views/s3file/AlarmReport'),
                name: "/AlarmReport/Index",
                meta: {
                    title: '报警摘要报表'
                }
            },
            {
                path: '/EditPasswordLog',
                component: () => import('views/user_rights/EditPasswordLog'),
                name: "/user_rights/EditPasswordLog",
                meta: {
                    title: '密码修改日志'
                }
            },
            {
                path: '/report/UnboundStat',
                component: () => import('views/report/UnboundStat'),
                name: "/report/UnboundStat",
                meta: {
                    title: '解绑报表'
                }
            },
            {
                path: '/report/IoTInsight',
                component: () => import('views/report/IoTInsight'),
                name: "/report/IoTInsight",
                meta: {
                    title: 'IoT洞察'
                }
            },
            {
                path: '/report/AssetsSummary',
                component: () => import('views/report/AssetsSummary'),
                name: "/report/AssetsSummary  ",
                meta: {
                    title: '资产摘要报表'
                }
            },
            {
                path: '/report/installReport',
                component: () => import('views/report/installReport'),
                name: "/report/installReport  ",
                meta: {
                    title: '安装报表'
                }
            },
            {
                path: '/deviceAnalysis/index',
                component: () => import('views/deviceAnalysis/index'),
                name: "/deviceAnalysis/index  ",
                meta: {
                    title: '设备分析'
                }
            },
            {
                path: '/device/deviceInsight',
                component: () => import('views/device/deviceInsight'),
                name: "/device/deviceInsight",
                meta: {
                    title: '设备洞察'
                }
            },
            {
                path: '/device/aiDiagnosis',
                component: () => import('views/device/aiDiagnosis'),
                name: "/device/aiDiagnosis",
                meta: {
                    title: 'AI诊断'
                }
            },
        ]
    },

    {
        path: '/login',
        component: () => import('views/login/Index'),
        meta: {
            title: '登录'
        },
    },
    {
        path: '/sso',
        component: () => import('views/login/sso'),
        meta: {
            title: 'SSO接收'
        },
    },
    {
        path: '/ssologin',
        component: () => import('views/login/ssoLogin'),
        meta: {
            title: 'SSO登录'
        },
    },
    {
        path: '/welcome',
        component: () => import('views/login/welcome'),
        meta: {
            title: 'welcome'
        },
    },
    {
        path: '/deviceMonitor',
        name: '/deviceMonitor',
        component: () => import('views/report/deviceMonitor'),
        meta: {
            title: '监控'
        },
    },
    {
        path: '/clientlogin',
        component: () => import('views/client/loginClient'),
        meta: {
            title: '客户登录'
        },
    },
    {
        path: '/clause',
        component: () => import('views/default/clause'),
        meta: {
            title: '法律条款'
        },
    },
    {
        path: '/testReport',
        component: () => import('views/default/testReport'),
        meta: {
            title: '测试报表'
        },
    },

    {
        path: '/client',
        component: () => import('views/home/HomeindexClient'),
        meta: {
            title: '客户门户-默认页'
        },
        children: [{
            path: '/client/default',
            component: () => import('views/client/default2'),
            name: "/client/default",
            meta: {
                title: '客户门户-首页'
            },
        }, {
            path: '/client/loginClient',
            component: () => import('views/client/loginClient'),
            name: "/client/loginClient",
            meta: {
                title: '客户门户-登录'
            },
        }, {
            path: '/client/noticeList',
            component: () => import('views/client/noticeList'),
            name: "/client/noticeList",
            meta: {
                title: '客户门户-站内信'
            },
        }, {
            path: '/client/AlarmList',
            component: () => import('views/client/AlarmList'),
            name: "/client/AlarmList",
            meta: {
                title: '客户门户-告警管理'
            },
        }, {
            path: '/client/Account',
            component: () => import('views/client/Account'),
            name: "/client/Account",
            meta: {
                title: '客户门户-账号管理'
            },
        }, {
            path: '/client/monitor',
            component: () => import('views/client/monitor'),
            name: "/client/monitor",
            meta: {
                title: '客户门户-设备监控'
            },
        }, {
            path: '/client/deviceStatistics',
            component: () => import('views/client/deviceStatistics'),
            name: "/client/deviceStatistics",
            meta: {
                title: '客户门户-统计报表'
            },
        }, {
            path: '/client/editPassword',
            component: () => import('views/client/editPassword'),
            name: "/client/editPassword",
            meta: {
                title: '客户密码修改'
            },
        }, {
            path: '/client/opensoon1',
            component: () => import('views/client/opensoon'),
            name: "待开发页",
            meta: {
                title: '待开发页'
            },
        }, {
            path: '/client/opensoon2',
            component: () => import('views/client/opensoon'),
            name: "待开发页",
            meta: {
                title: '待开发页'
            },
        }, {
            path: '/client/maintainList',
            component: () => import('views/client/maintainList'),
            name: "/client/maintain",
            meta: {
                title: '例行保养'
            },
        }, {
            path: '/client/deviceDetail',
            component: () => import('views/client/deviceDetail'),
            name: "/client/deviceDetail",
            meta: {
                title: '空压机列表'
            },
        },


        ],
    },
    {
        path: '/NoticeDetail',
        component: () => import('views/Alarm/NoticeDetail.vue'),
        meta: {
            title: '商业信息推送'
        },
    },
    {
        path: '/ResetPassword',
        component: () => import('views/client/ResetPassword.vue'),
        meta: {
            title: '忘记密码'
        },
    },
    {
        path: '/ScreenMonitor1',
        component: () => import('views/ScreenMonitor/index1'),
        meta: {
            title: '大屏监控'
        },
    },
    {
        path: '/ScreenMonitor2',
        component: () => import('views/ScreenMonitor/index2'),
        meta: {
            title: '大屏监控'
        },
    },
    {
        path: '/ScreenMonitor3',
        component: () => import('views/ScreenMonitor/index3'),
        meta: {
            title: '大屏监控'
        },
    },
    {
        path: '/ScreenMonitor4',
        component: () => import('views/ScreenMonitor/index4'),
        meta: {
            title: '大屏监控'
        },
    },
    {
        path: '/indexInstallation',
        component: () => import('views/ScreenMonitor/index-Installation'),
        meta: {
            title: '大屏监控'
        },
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

//导航守卫
router.beforeEach((to, from, next) => {
    //修改标题
    // document.title=to.matched[0].meta.title;
    // store.commit("changeLeftnavnum",to.matched[0].path);
    // next();    
    var domain = location.href.toLowerCase();
    console.log(location.href);
    var mainRouterList = [];
    var clientRouterList = [];
    routes.forEach(r => {
        if (r.path == "/") {
            r.children.forEach(c => {
                mainRouterList.push({
                    path: c.path
                })
            })
        }
        else if (r.path == "/client") {
            r.children.forEach(c => {
                clientRouterList.push({
                    path: c.path
                })
            })
        }
        else {
            mainRouterList.push({
                path: r.path
            })
        }
    })

    var toPath = to.path;
    var fromPath = from.path;
    var isExist = false;
    mainRouterList.forEach(r => {
        if (r.path == toPath)
            isExist = true;
    });
    var isExistClient = false;
    clientRouterList.forEach(r => {
        if (r.path == toPath)
            isExistClient = true;
    });
    if (localStorage.getItem('userInfo')) {
        domain = domain.replace("https://", "");
        if (domain.indexOf("/") == -1) {//定位首页,根据总部web平台还是客户平台
            if (domain.indexOf("testirapweb") >= 0 || domain.indexOf("iraphelix") >= 0 || domain.indexOf("testirweb") >= 0 || domain.indexOf("irhelix") >= 0 || domain.indexOf("testgdweb") >= 0 || domain.indexOf("gdiconn") >= 0 || domain.indexOf("gdapiconn") >= 0) {
                next({
                    path: '/ssologin'
                });
            }
            else if (domain.indexOf("testapweb") >= 0 || (domain.indexOf("aphelix") >= 0 && domain.indexOf("iraphelix") < 0) || domain.indexOf("testcsweb") >= 0 || domain.indexOf("helix") >= 0 || domain.indexOf("testgdcsweb") >= 0 || domain.indexOf("iconn") >= 0) {
                next({
                    path: '/clientlogin'
                });
            }
            else {
                next({
                    path: '/ssologin'
                });
            }
        }
        /////////////////////////////////////////
        else {
            if (toPath === '/login' || toPath === '/sso' || toPath === '/ssologin' || toPath === '/clientlogin' || toPath === '/welcome' || toPath === '/clause' || toPath === '/deviceMonitor' || toPath === '/devicemonitor' || toPath === '/testreport' || toPath === '/NoticeDetail' || toPath === '/ResetPassword') {//跳转登录页面
                next();
                return;
            }
            //非登录页面控制，判断路径是否有效
            else if (domain.indexOf("testirapweb") >= 0 || domain.indexOf("iraphelix") >= 0 || domain.indexOf("testirweb") >= 0 || domain.indexOf("irhelix") >= 0 || domain.indexOf("testgdweb") >= 0 || domain.indexOf("gdiconn") >= 0 || domain.indexOf("gdapiconn") >= 0) {//总部web平台
                if (!isExist) {
                    next({
                        path: '/ssologin'
                    });
                }
                else {
                    next();
                }
            }
            else if (domain.indexOf("testapweb") >= 0 || (domain.indexOf("aphelix") >= 0 && domain.indexOf("iraphelix") < 0) || domain.indexOf("testcsweb") >= 0 || domain.indexOf("helix") >= 0 || domain.indexOf("testgdcsweb") >= 0 || domain.indexOf("iconn") >= 0) {
                if (!isExistClient) {
                    next({
                        path: '/clientlogin'
                    });
                }
                else {
                    next();
                }
            }
            else {
                next();
            }
        }
        ///////////////////////////////////////////
    } else {//缓存过期处理
        if (toPath === '/login' || toPath === '/sso' || toPath === '/ssologin' || toPath === '/clientlogin' || toPath === '/clause' || toPath === '/deviceMonitor' || toPath === '/devicemonitor' || toPath === '/testreport' || toPath === '/welcome' || toPath === '/NoticeDetail' || toPath === '/ResetPassword') {//跳转登录页面
            next();
        } else {
            if (fromPath === '/login' || fromPath === '/clientlogin' || fromPath === '/clause' || toPath === '/deviceMonitor' || toPath === '/devicemonitor' || toPath === '/testreport' || toPath === '/welcome' || toPath === '/NoticeDetail' || toPath === '/ResetPassword') {//从登录页面跳转到其他页面
                //总部web判断，登录页面定位
                if (domain.indexOf("testirapweb") >= 0 || domain.indexOf("iraphelix") >= 0 || domain.indexOf("testirweb") >= 0 || domain.indexOf("irhelix") >= 0 || domain.indexOf("testgdweb") >= 0 || domain.indexOf("gdiconn") >= 0 || domain.indexOf("gdapiconn") >= 0) {
                    if (!isExist) {
                        next({
                            path: '/ssologin'
                        });
                    }
                    else {
                        next();
                    }
                }
                //客户端web判断，登录页面定位
                else if (domain.indexOf("testapweb") >= 0 || (domain.indexOf("aphelix") >= 0 && domain.indexOf("iraphelix") < 0) || domain.indexOf("testcsweb") >= 0 || domain.indexOf("helix") >= 0 || domain.indexOf("testgdcsweb") >= 0 || domain.indexOf("iconn") >= 0) {
                    if (!isExistClient) {
                        next({
                            path: '/clientlogin'
                        });
                    }
                    else {
                        next();
                    }
                }
                else {
                    next();
                }
            }
            else {
                //非登录页面的，其他页面之间跳转
                if (domain.indexOf("oss") >= 0) {
                    next();
                }
                else if (domain.indexOf("testirapweb") >= 0 || domain.indexOf("iraphelix") >= 0 || domain.indexOf("testirweb") >= 0 || domain.indexOf("irhelix") >= 0 || domain.indexOf("testgdweb") >= 0 || domain.indexOf("gdiconn") >= 0 || domain.indexOf("gdapiconn") >= 0) {
                    next({
                        path: '/ssologin'
                    });
                }
                else if (domain.indexOf("testapweb") >= 0 || (domain.indexOf("aphelix") >= 0 && domain.indexOf("iraphelix") < 0) || domain.indexOf("testcsweb") >= 0 || domain.indexOf("helix") >= 0 || domain.indexOf("testgdcsweb") >= 0 || domain.indexOf("iconn") >= 0) {
                    next({
                        path: '/clientlogin'
                    });
                }
                else {
                    next({
                        path: '/ssologin'
                    });
                }
            }
        }
    }
    //跳转修改密码页
    if (localStorage.getItem('isneedchange') >= 500) {
        //后台管理系统跳转
        if (domain.indexOf("testirapweb") >= 0 || domain.indexOf("iraphelix") >= 0 || domain.indexOf("testirweb") >= 0 || domain.indexOf("irhelix") >= 0 || domain.indexOf("testgdweb") >= 0 || domain.indexOf("gdiconn") >= 0) {
            if (toPath === '/password' || toPath === '/login') {
                next()
            } else {
                next('/password')
            }
        } else if (domain.indexOf("testapweb") >= 0 || domain.indexOf("aphelix") >= 0 || domain.indexOf("testcsweb") >= 0 || domain.indexOf("helix") >= 0 || domain.indexOf("testgdcsweb") >= 0 || domain.indexOf("iconn") >= 0) {
            //客户门户跳转
            if (toPath === '/client/editPassword' || toPath === '/clientlogin') {
                next()
            } else {
                next('/client/editPassword')
            }
        } else if (domain.indexOf("localhost") >= 0) {
            debugger
            //本地跳转
            if (toPath === '/client/editPassword' || toPath === '/clientlogin' || toPath === '/password' || toPath === '/login') {
                next()
            } else if (domain.indexOf("client") >= 0) {
                next('/client/editPassword')
            } else {
                next('/password')
            }
        } else {
            next()
        }

    }

});

export default router
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
